import { MAIN_IMAGE_ROOT } from 'app_config';
import type { HookFormSubmitHandler } from 'common/models';
import { useGetPublicCompanySettingsQuery } from 'common/queries';
import useAuth from 'common/useAuth';
import { ImageComponent } from 'components';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';
import { Link } from 'react-router-dom';
import logo from 'static/images/logo_dark.png';

import type { LoginFormValues } from './LoginForm';
import LoginForm from './LoginForm';

interface Props {
  refreshTokenFailed: boolean;
  handleLogin: HookFormSubmitHandler<LoginFormValues>;
}

const LoginPart: React.FC<Props> = (props): React.ReactElement => {
  const { refreshTokenFailed, handleLogin } = props;

  const { t } = useCustomTranslation();
  const { tenantCode, clearTenant } = useAuth();

  const publicCompanySettingsQuery = useGetPublicCompanySettingsQuery(tenantCode);

  const logoUrl = publicCompanySettingsQuery.data?.logoUrl;
  const companyName = publicCompanySettingsQuery.data?.name;

  return (
    <>
      <div className="logo">
        <ImageComponent
          url={logoUrl ? `${MAIN_IMAGE_ROOT}${logoUrl}` : logo}
          className="img-fluid"
        />
      </div>
      {companyName && <div className="LoginPage_CompanyName heading">{companyName}</div>}
      <LoginForm onSubmit={handleLogin} refreshTokenFailed={refreshTokenFailed} />
      <div className="links">
        <Link to="/password" className="fake-button mb-2">
          {t('login.forgetPasswordLink')}
        </Link>
        <a onClick={() => clearTenant()} className="fake-button">
          {t('login.changeCompanyLink')}
        </a>
      </div>
    </>
  );
};

export default LoginPart;
